import AppStore from '../stores/app-store';

export const setIsEmptyOrg = (isEmpty: boolean) => {
  AppStore.isEmptyOrg = isEmpty;
};
